import Fetch from '../apiConfig/apiConfig';
import { AxiosPromise } from 'axios';
import { IBasketResponse } from './IBasketResponse';

export const getBasketDetails = (): AxiosPromise<IBasketResponse> => {
  return Fetch().then(axios => axios.get('orders/get'));
};
